module.exports = __webpack_public_path__ + "fonts/Inter-Bold.88fa7ae.ttf";